var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-restricted-syntax */
import React from 'react';
import each from 'lodash/each';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';
import CompanyStore from 'stores/CompanyStore/store';
import { getUploadUrl } from 'utils/UploadUtils';
import { UploadTypes } from 'constants/AdminConstants';
import Expectations from './Expectations';
var getStateFromStores = function () { return CompanyStore.getCompanyInfo(); };
var PlayerExpectations = /** @class */ (function (_super) {
    __extends(PlayerExpectations, _super);
    function PlayerExpectations(props) {
        var _this = _super.call(this, props) || this;
        _this.state = getStateFromStores();
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        return _this;
    }
    PlayerExpectations.prototype.componentDidMount = function () {
        CompanyStore.addChangeListener(this.onChangeHandler);
    };
    PlayerExpectations.prototype.componentWillUnmount = function () {
        CompanyStore.removeChangeListener(this.onChangeHandler);
    };
    PlayerExpectations.prototype.onChangeHandler = function () {
        this.setState(getStateFromStores());
    };
    PlayerExpectations.prototype.getExpectations = function () {
        var userId = parseInt(String(this.state.current_user.id), 10);
        var products = this.state.products.reduce(function (aggregate, product) {
            var _a;
            return __assign(__assign({}, aggregate), (_a = {}, _a[product.id] = product.product_name, _a));
        }, {});
        var userExpectations = {};
        var i;
        var users = {};
        each(this.state.users, function (user) {
            if (!user.deactivated && parseInt(String(user.id), 10) !== userId) {
                users[user.id] = user;
                userExpectations[user.id] = {
                    user_id: user.id,
                    goals: [],
                    expectations: [],
                    lowestPercentComplete: 0
                };
            }
        });
        each(this.state.goals, function (goal) {
            var goalUserId = parseInt(String(goal.user_id), 10);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var activity = goal.activity;
            // Push quantity goal
            if (parseInt(String(goal.goal), 10) > 0) {
                if (userExpectations[goalUserId]) {
                    userExpectations[goalUserId].expectations.push({
                        key: "".concat(goal.id, "-quantity"),
                        goal: parseInt(String(goal.goal), 10),
                        actual: parseInt(String(activity.quantity), 10),
                        frequency: parseInt(String(goal.goal_frequency), 10),
                        isCurrency: false,
                        productName: products[goal.product_id],
                        percentComplete: Math.min(1, parseInt(String(activity.quantity), 10) / parseInt(String(goal.goal), 10))
                    });
                }
            }
            // Push value goal
            if (parseInt(String(goal.value_goal), 10) > 0) {
                if (userExpectations[goalUserId]) {
                    userExpectations[goalUserId].expectations.push({
                        key: "".concat(goal.id, "-value"),
                        goal: parseInt(String(goal.value_goal), 10),
                        actual: parseInt(String(activity.value), 10),
                        frequency: parseInt(String(goal.value_goal_frequency), 10),
                        isCurrency: true,
                        productName: products[goal.product_id],
                        percentComplete: Math.min(1, parseInt(String(activity.value), 10) / parseInt(String(goal.value_goal), 10))
                    });
                }
            }
        });
        for (i in userExpectations) {
            if (userExpectations[i].expectations.length) {
                userExpectations[i].expectations = sortBy(userExpectations[i].expectations, function (expectation) { return expectation.percentComplete; });
                if (userExpectations[i].expectations[0]) {
                    userExpectations[i].lowestPercentComplete = parseInt(String(userExpectations[i].expectations[0].percentComplete), 10);
                }
            }
        }
        var userExpectationsArray = values(userExpectations);
        var sortedExpectations = sortBy(userExpectationsArray, function (userExpectation) { return userExpectation.lowestPercentComplete; });
        return sortedExpectations
            .filter(function (userExpectation) { return userExpectation.expectations.length; })
            .map(function (userExpectation) {
            var user = users[userExpectation.user_id];
            var playerInfo = {
                name: user.user_name,
                profilePic: getUploadUrl(user.upload_url || undefined, UploadTypes.UPLOAD_TYPE_USER) || ''
            };
            var lowestPercentComplete = 0;
            if (userExpectation.expectations[0]) {
                lowestPercentComplete = userExpectation.expectations[0].percentComplete * 100;
            }
            return (_jsx(Expectations, { isCoachsArea: true, playerInfo: playerInfo, expectations: userExpectation.expectations, lowestPercentComplete: lowestPercentComplete }, userExpectation.user_id));
        });
    };
    PlayerExpectations.prototype.render = function () {
        return (_jsx("div", { className: "push-bottom", children: _jsxs("div", { className: "card card-pad-md", children: [_jsx("div", { className: "g pad-bottom", children: _jsx("div", { className: "u-sm-8 u-md-8", children: _jsx("h3", { className: "no-layout", children: "Other expectations" }) }) }), this.getExpectations()] }) }));
    };
    return PlayerExpectations;
}(React.Component));
export default PlayerExpectations;
